export default {
  state: {
    // 主入口标签页
    mainTabs: [],
    // 当前标签页名
    mainTabsActiveName: '',
    key:[]
  },
  mutations: {
    updateMainTabs (state, tabs) {
      state.mainTabs = tabs
    },
    updateMainTabsActiveName (state, name) {
      state.mainTabsActiveName = name
    },
    updateKey (state, key) {
      state.key = key
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tab.js